<template>
    <div class="space-y-10"
         v-if="settings.paypal.is_automation_possible || settings.bank_transfer.is_automation_possible">

        <div class="space-y-4" v-if="settings.paypal.is_automation_possible">
            <header-bar title="Paypal Payout automation" size="xsmall"></header-bar>

            <div class="grid lg:grid-cols-2 gap-8">
                <paypal-automation-settings
                    :program-id="programId"
                    :settings="settings.paypal.automation_settings"
                ></paypal-automation-settings>

                <toggle-paypal-automation></toggle-paypal-automation>

            </div>
        </div>

        <div class="space-y-4" v-if="settings.bank_transfer.is_automation_possible">
            <header-bar title="Wire Transfer (Wise) Payout automation" size="xsmall"></header-bar>

            <div class="grid lg:grid-cols-2 gap-8">
                <bank-transfer-automation-settings
                    :program-id="programId"
                    :settings="settings.bank_transfer.automation_settings"
                ></bank-transfer-automation-settings>

                <toggle-bank-transfer-automation></toggle-bank-transfer-automation>
            </div>
        </div>

        <div class="space-y-4">
            <header-bar title="Pending payouts" size="xsmall"></header-bar>

            <div class="grid lg:grid-cols-2 gap-8">

                <div class="bg-white rounded border p-6">
                    <div class="mb-4 text-sm text-gray-900">Scheduled payouts</div>
                    <div class="flex items-baseline">
                        <h3 class="text-2xl font-semibold leading-tight xl:text-3xl">
                            {{ pendingPayouts.count }}
                        </h3>
                    </div>

                </div>
                <div class="bg-teal-500 rounded p-6">
                    <div class="mb-4 text-sm text-white">Total amount</div>
                    <h3 class="text-2xl font-semibold leading-tight xl:text-3xl text-white">
                        {{ pendingPayouts.amount }}
                    </h3>
                </div>

            </div>
        </div>

        <div class="space-y-4">
            <header-bar title="History" size="xsmall"></header-bar>

            <scheduled-payouts-history
                v-if="scheduledPayoutHistoryList.length > 0"
                :program-id="programId"
                :scheduled-payouts="scheduledPayoutHistoryList"
            ></scheduled-payouts-history>
            <div class="bg-white rounded overflow-hidden border" v-else>
                <div class="flex justify-center items-center text-center py-20">
                    <div>
                        <div class="flex justify-center items-center p-4">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                <path fill="none" d="M0 0h24v24H0z"/>
                                <path
                                    d="M14 2a8 8 0 0 1 3.292 15.293A8 8 0 1 1 6.706 6.707 8.003 8.003 0 0 1 14 2zm-4 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12zm1 1v1h2v2H9a.5.5 0 0 0-.09.992L9 13h2a2.5 2.5 0 1 1 0 5v1H9v-1H7v-2h4a.5.5 0 0 0 .09-.992L11 15H9a2.5 2.5 0 1 1 0-5V9h2zm3-5a5.985 5.985 0 0 0-4.484 2.013 8 8 0 0 1 8.47 8.471A6 6 0 0 0 14 4z"/>
                            </svg>
                        </div>
                        <h2 class="font-semibold text-lg mb-2">Automation payout requests and history will be
                            here</h2>
                        <p class="text-gray-500 text-sm">When automated payouts happen, you'll see them listed
                            here.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-white rounded overflow-hidden border" v-else>
        <div class="flex justify-center items-center text-center py-20">
            <div>
                <div class="flex justify-center items-center p-4">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                        <path
                            d="M6 8V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6ZM19 10H5V20H19V10ZM11 15.7324C10.4022 15.3866 10 14.7403 10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 14.7403 13.5978 15.3866 13 15.7324V18H11V15.7324ZM8 8H16V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8Z">
                        </path>
                    </svg>
                </div>
                <h2 class="font-semibold text-lg mb-2">Automate partner payouts</h2>
                <p class="text-gray-500 text-sm mb-4">
                    Connect your PayPal or Wise account to send payouts automatically—no manual work required.
                </p>
                <div class="space-x-4 flex justify-center w-full">

                    <modal :title="'PayPal Mass Pay integration'" size="small" name="paypal_integration">
                        <template #toggle>
                            <btn>Connect PayPal</btn>
                        </template>
                        <template #body>
                            <div class="space-y-4 text-left">
                                <alert type="error" v-if="integrations.paypal.connect_error">
                                    {{ integrations.paypal.connect_error }}
                                </alert>
                                <div class="grid gap-y-6 gap-x-8">
                                    <text-field
                                        label="Client ID"
                                        field-id="client_id"
                                        name="client_id"
                                        v-model="integrations.paypal.client_id"
                                        type="text"
                                        autofocus="true"
                                        required="true">
                                    </text-field>
                                    <text-field
                                        label="Secret"
                                        field-id="client_secret"
                                        name="client_secret"
                                        v-model="integrations.paypal.client_secret"
                                        type="password"
                                        :show_reveal_password_icon="true"
                                        placeholder="e.g. ENv_iRgBP2rBw...9Mk"
                                        required="true">
                                        <template #note>
                                            To obtain your PayPal Client ID and Secret, please
                                            <a href="#" data-beacon-article="43" class="underline">click
                                                here</a> for instructions on how to retrieve them from your account.
                                        </template>
                                    </text-field>
                                </div>
                            </div>
                        </template>
                        <template #footer>
                            <btn :loading="loading.integrations_connect" @click="connectPayPal">Connect</btn>
                        </template>
                    </modal>
                    <modal :title="'Wise Mass Pay integration'" size="small" name="wise_integration">
                        <template #toggle>
                            <btn>Connect Wise</btn>
                        </template>
                        <template #body>
                            <div class="space-y-4 text-left">
                                <alert type="error" v-if="integrations.wise.connect_error">
                                    {{ integrations.wise.connect_error }}
                                </alert>
                                <div class="grid gap-y-6 gap-x-8">
                                    <text-field
                                        label="API token"
                                        field-id="api_token"
                                        name="api_token"
                                        v-model="integrations.wise.api_token"
                                        type="password"
                                        :show_reveal_password_icon="true"
                                        placeholder="e.g. a1cd3c6b-38...4f0f"
                                        autofocus="true"
                                        required="true">
                                        <template #note>
                                            To obtain your API token, log in to Wise account and navigate to your
                                            Settings page and click API tokens. On this page, users can generate and
                                            access their personal token.
                                        </template>
                                    </text-field>
                                </div>
                            </div>
                        </template>
                        <template #footer>
                            <btn :loading="loading.integrations_connect" @click="connectWise">Connect</btn>
                        </template>
                    </modal>

                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {inject, ref} from "vue";

const props = defineProps({
    programId: {
        type: Number,
        required: true,
    },
    settings: {
        type: Object,
        required: true,
    },
    pendingPayouts: {
        type: Object,
        required: true,
    },
    scheduledPayoutHistoryList: {
        type: Object,
        required: true,
    },
    integrations: {
        type: Object,
        default: {
            paypal: {
                client_id: null,
                client_secret: null,
                connect_error: null,
            },
            wise: {
                api_token: null,
                connect_error: null,
            }
        }
    }
});

const emitter = inject('emitter');

const programId = props.programId;
const settings = ref(props.settings);
const integrations = ref(props.integrations);
const pendingPayouts = ref(props.pendingPayouts);
const scheduledPayoutHistoryList = ref(props.scheduledPayoutHistoryList);

const loading = ref({
    integrations_connect: false
});

const connectPayPal = () => {
    if (loading.value.integrations_connect) {
        return;
    }

    loading.value.integrations_connect = true;

    axios
        .post(route('app_int.integrations.paypal.mass-payout.connect', {program: programId}), {
            with_automations: true,
            client_id: integrations.value.paypal.client_id,
            client_secret: integrations.value.paypal.client_secret,
        })
        .then(response => {
            const status = parseInt(response.data.status ?? -1);
            if (status === 1) {

                const automations = response.data.automations ?? null;
                if (automations) {
                    settings.value = automations;
                }

                emitter.emit('modal-off', 'paypal_integration');
            } else {
                integrations.value.paypal.connect_error = 'Failed to connect';
            }
        })
        .catch(error => {
            integrations.value.paypal.connect_error = 'Failed to connect';
        })
        .finally(() => loading.value.integrations_connect = false);
}

const connectWise = () => {
    if (loading.value.integrations_connect) {
        return;
    }

    loading.value.integrations_connect = true;

    axios
        .post(route('app_int.integrations.bank-transfer.mass-payout.connect', {program: programId}), {
            with_automations: true,
            api_token: integrations.value.wise.api_token,
        })
        .then(response => {
            const status = parseInt(response.data.status ?? -1);
            if (status === 1) {

                const automations = response.data.automations ?? null;
                if (automations) {
                    settings.value = automations;
                }

                emitter.emit('modal-off', 'wise_integration');
            } else {
                integrations.value.paypal.connect_error = 'Failed to connect';
            }
        })
        .catch(error => {
            integrations.value.wise.connect_error = 'Failed to connect';
        })
        .finally(() => loading.value.integrations_connect = false);
}

</script>


